import React from 'react';

import { Typography } from 'lighthouse';

import Reveal from '@/widgets/ServiceLanding/Reveal';

import { SectionHeadingProps } from './models';

const SectionHeading = ({ badge, title, subtitle, dark = false, className = '', subtitleClassName = '' }: SectionHeadingProps) => {
    return (
        <div className={`mx-auto mb-10 max-w-2xl text-center md:mb-14 ${className}`}>
            {badge && (
                <Reveal>
                    <Typography
                        variant='caption'
                        component='span'
                        color={dark ? 'whiteHighEmphasis' : 'primary'}
                        className={`mb-4 inline-block rounded-full px-4 py-1.5 font-medium ${dark ? 'bg-white/10 text-sky-300' : 'bg-primary/10'}`}>
                        {badge}
                    </Typography>
                </Reveal>
            )}
            <Reveal delay={80}>
                <Typography
                    variant='h5'
                    component='h2'
                    color={dark ? 'whiteHighEmphasis' : 'blackHighEmphasis'}
                    className={`font-bold leading-[1.5] md:text-4xl md:leading-[1.5] ${dark ? 'text-white' : ''}`}>
                    {title}
                </Typography>
            </Reveal>
            {subtitle && (
                <Reveal delay={160}>
                    <Typography
                        variant='body2'
                        component='p'
                        color={dark ? 'whiteMediumEmphasis' : 'blackMediumEmphasis'}
                        className={`mt-2 leading-7 md:text-base md:leading-7 ${dark ? 'text-white/70' : ''} ${subtitleClassName}`}>
                        {subtitle}
                    </Typography>
                </Reveal>
            )}
        </div>
    );
};

export default SectionHeading;
